import { render, staticRenderFns } from "./ProductCardMediaTypeInfo.vue?vue&type=template&id=4199967e&scoped=true&"
import script from "./ProductCardMediaTypeInfo.vue?vue&type=script&lang=js&"
export * from "./ProductCardMediaTypeInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardMediaTypeInfo.vue?vue&type=style&index=0&id=4199967e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199967e",
  null
  
)

export default component.exports